export default {"src":"/_next/static/media/cimigo_logo_2.86303e4e.svg","height":54,"width":155,"blurWidth":0,"blurHeight":0};